import { render, staticRenderFns } from "./HistoryRemindTask.vue?vue&type=template&id=64711bd2&scoped=true"
import script from "./HistoryRemindTask.vue?vue&type=script&lang=js"
export * from "./HistoryRemindTask.vue?vue&type=script&lang=js"
import style0 from "./HistoryRemindTask.vue?vue&type=style&index=0&id=64711bd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64711bd2",
  null
  
)

export default component.exports